import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { NgbTabset, NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbNav, NgbNavConfig} from '@ng-bootstrap/ng-bootstrap';

import { ColumnChooserService, GridComponent, PageService, ToolbarService, VirtualScrollService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICompanyContactStatus, ICompanyDetail } from '../../shared/models/index';
import { AuthorizationService, CompanyContactService, StorageManagerService } from '../../shared/services/index';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DeleteButtonComponent } from '../common/delete-button/delete-button.component';
import { Utilities } from '../../shared/services/utilities';
@Component({
    selector: 'app-company-dashboard',
    templateUrl: './company-dashboard.component.html',
    styleUrls: ['./company-dashboard.component.scss'],
    providers: [ToolbarService, ColumnChooserService, PageService, VirtualScrollService],
    animations: [fadeInOut],
    standalone: false
})

export class CompanyDashboardComponent implements OnInit {
    @ViewChild('company_grid')
    public company_grid: GridComponent;
    @ViewChild('drafts_grid')
    public draftsGrid: GridComponent;
    @ViewChild('ngbNav', { static: true })
    public tabset: NgbNav;
    @ViewChild('tooltip')
    public tooltip: TooltipComponent;
    @ViewChild('deleteCompany')
    public deleteButton: DeleteButtonComponent;
    @ViewChild('deleteDraftCompany')
    public deleteButtonDrafts: DeleteButtonComponent;

    @Input() company_grid_data: ICompanyDetail[];
    @Input() drafts_grid_data: ICompanyDetail[];
    public initialPage: Object;
    public toolbarOptions: Object;
    errorMessage: string;
    count_company: number;
    count_draftcompany: number;
    FORM_STATUS_ACTIVE = 'A';
    FORM_STATUS_DRAFT = 'D';
    companyStatus: ICompanyContactStatus;
    loading = true;
    public formatOptions: any;
    activeTab: string;
    sub: Subscription;
    public clipmodecolumn = { class: 'e-tooltipcolumn' };
    hasWritePermission = false;
    hasDeletePermission = false;
    selectedCompanyRevisionId: number | undefined;

    /**
     * Explicit selection persistence across paging/sorting/filtering.
     * Syncfusion persistSelection can still drop selection depending on templates/checkbox visibility,
     * so we keep the selected primary key and re-apply it on actionComplete.
     */
    private selectedCompanyRevisionIds = {
        company: null as number | null,
        drafts: null as number | null
    };

  constructor(private router: Router, private toastr: ToastrService, private companySvc: CompanyContactService, private sanitizer: DomSanitizer,
              private storageManagerService: StorageManagerService, private authorizationService: AuthorizationService, ) {
  }

    ngOnInit(): void {
        this.checkUserPermission();

        this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, this.hasWritePermission);

        this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
        this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

        // clear out previously saved info
        sessionStorage['currentCompanyId'] = null;

        // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
        this.initTabIndex();

        this.getCompanies();

        this.activeTab = 'company';

        // Fix for footer spacing issues
        document.getElementsByTagName('footer')[0].classList.add("footer-spacing-fix");
    }

    initTabIndex() {
      (document.activeElement as HTMLElement).blur();

      const main = document.getElementById("firstDiv");

      if (main) {
        main.focus();
      }
    }

  checkUserPermission() {
    if (this.authorizationService.hasPermission('SSDP.CanWriteCompany')) {
      this.hasWritePermission = true;
    }
    if (this.authorizationService.hasPermission('SSDP.CanDeleteCompany')) {
      this.hasDeletePermission = true;
    }
  }

  tabChanged(event) {
    this.activeTab = event.nextId;
    this.selectedCompanyRevisionId = undefined;

    // restore selection when switching tabs
    setTimeout(() => this.restoreSelectionForActiveTab());
  }

  createCustomToolbarItems(deletePermission: boolean, writePermission: boolean) {
    let toolbarItems = [];

    if (writePermission) {
      toolbarItems.push(
          {
            text: 'Create New Company',
            tooltipText: 'Add a new company to this list',
            prefixIcon: 'fas fa-plus',
            id: 'create-form-btn'
          }
      );
    }

    if(deletePermission){
        toolbarItems.push(
            {
                text: 'Delete Company',
                tooltipText: 'Delete the selected company',
                prefixIcon: 'fas fa-trash',
                id: 'tool-bar-delete'
            }
        )
    }

    toolbarItems.push('Search');

    return toolbarItems;
  }

  tooltipValue(args) {

    let grid;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      switch (this.activeTab) {
        case 'drafts':
          grid = this.draftsGrid;
          break;
        case 'company':
          grid = this.company_grid;
          break;
      }

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltip.cssClass = 'customTooltip';
      this.tooltip.content = rowData[(rowInfo.column as any).field];
    }
  }

    // Grid toolbar click event handler
    toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'create-form-btn') {
            this.router.navigate(['company-details']);
        }
        if (args.item.id === 'tool-bar-delete' && this.selectedCompanyRevisionId) {
            if(this.company_grid){
                this.deleteButton.revisionId = this.selectedCompanyRevisionId.toString();
                this.deleteButton.openDeleteModal();
            }
            else if(this.draftsGrid){
                this.deleteButtonDrafts.revisionId = this.selectedCompanyRevisionId.toString();
                this.deleteButtonDrafts.openDeleteModal();
            }
        }
    }

  // Retrieve a list of companies
  getCompanies() {
    this.companySvc.GetCompanyDashboard().subscribe(data => {
        if (data && data.length) {
          this.loading = false;

          this.drafts_grid_data = data.filter(p => p.isDraftMode === true);
          this.count_draftcompany = this.drafts_grid_data.length;

          this.company_grid_data = data.filter(p => p.isDraftMode === false);
          this.count_company = this.company_grid_data.length;

        } else {
          this.loading = false; // no data so stop the spinner
        }
      },
      error => {
        this.loading = false;
        this.toastr.error(error.message);
      }
    );
  }

  // Change grid filter operator from "startwith" to "contains" for columns that are string
  public begin(args: any): void {
    if (args.requestType === 'filtering') {
      if (args.columns) {
        args.columns.forEach(col => {
          switch (args.currentFilteringColumn) {
            case 'version':
              args.currentFilterObject.value = `${args.currentFilterObject.value}.0`;
              break;
            case 'modified':
              break;
            default:
              col.operator = 'contains';       // set the “contains” operator for the column
              break;
          }
        });
      }
    }
  }

  // Display detail of a single company
  viewCompany(companyRevisionId: string, companyId: string) {
    if (companyRevisionId) {
      sessionStorage['currentCompanyRevisionId'] = companyRevisionId;

      this.router.navigate(['/company-details', companyRevisionId]);
    }
  }

    companyGridRowSelected(e: any){
        const id = e?.data?.companyRevisionId;
        this.selectedCompanyRevisionId = id;
        if (this.activeTab === 'drafts') {
          this.selectedCompanyRevisionIds.drafts = id;
        } else {
          this.selectedCompanyRevisionIds.company = id;
        }
    }

    companyGridRowDeselected() {
        this.selectedCompanyRevisionId = undefined;
        if (this.activeTab === 'drafts') {
          this.selectedCompanyRevisionIds.drafts = null;
        } else {
          this.selectedCompanyRevisionIds.company = null;
        }
    }

  /** Called by the grids after paging/sorting/filtering so we can reselect the row. */
  gridActionComplete(args: any) {
    switch (args?.requestType) {
      case 'paging':
      case 'sorting':
      case 'filtering':
      case 'searching':
      case 'refresh':
        this.restoreSelectionForActiveTab();
        break;
    }
  }

  private restoreSelectionForActiveTab() {
 const grid = this.activeTab === 'drafts' ? this.draftsGrid : this.company_grid;
 const id = this.activeTab === 'drafts' ? this.selectedCompanyRevisionIds.drafts : this.selectedCompanyRevisionIds.company;

 if (!grid || !id) {
 return;
 }

 const view = grid.getCurrentViewRecords() as any[];

 let rowIndex = -1;
 if (view && view.length) {
 for (let i =0; i < view.length; i++) {
 if (view[i] && view[i].companyRevisionId === id) {
 rowIndex = i;
 break;
 }
 }
 }

 if (rowIndex >=0) {
 grid.selectRow(rowIndex);
 }
}

  
}
